import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { sharedColors } from '../../../sharedStyles/styles'

const channel: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 83px 16px 79px',
}

const coverAsset: CSSObject = {
  height: '142px',
  width: '800px',
}

const accountName: CSSObject = {
  letterSpacing: '-0.5px',
  marginBottom: '2px',
}

const subscribeBtn: CSSObject = {
  backgroundColor: sharedColors.red,
  color: 'white',
  height: '36px',
  width: '110px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bold,
  letterSpacing: '0px',
  textTransform: 'uppercase',
}

const accountWrapper: CSSObject = {
  display: 'flex',
  alignItems: 'center',
}

const accountInfo: CSSObject = {
  marginLeft: '24px',
}

const subscriberTxt: CSSObject = {
  color: sharedColors.medGray,
  fontSize: fontSizes.medium,
}

const styles = {
  accountName,
  accountWrapper,
  accountInfo,
  coverAsset,
  channel,
  subscribeBtn,
  subscriberTxt,
}

export { styles }
